import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import messages from './messages'
import users from './users'
import broadcasts from './broadcasts'
import programs from './programs'
import surveys from './surveys'
import forums from './forums'
import provinces from './provinces'
import courseInterests from './courseInterests'
import videos from './videos'

// import content from './modules/content'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        messages,
        users,
        broadcasts,
        programs,
        surveys,
        forums,
        provinces,
        courseInterests,
        videos
        // content,
    }
})
